"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactEmail = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.ContactEmail = {
    priority: 60,
    label: 'fields.payload.upsell_stores.contact_email.label',
    fallbackLabel: 'Contact email',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    mfValidation: {
        pathToValidation: 'base/email',
    },
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'UPSELL_WEBSTORE_TO_PP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'UPSELL_WEBSTORE_TO_PP');
}
